import Rails from '@rails/ujs';
import { Config } from './config';
import { Util } from './util';

class ComplaintResponses {

    constructor() {
        this.CONFIG = new Config();
        this.FORM_NAME = 'complaintResponse';
        this.FORM = document.forms[this.FORM_NAME];
        this.FORM_COMPLAINT_ID = this.FORM['complaint_response[complaint_id]'];
        this.FORM_DATE = this.FORM['complaint_response[date]'];
        this.FORM_CLASSIFICATION = this.FORM['complaint_response[classification]'];
        this.FORM_CONTENT = this.FORM['complaint_response[content]'];
        this.FORM_GET_BTN_NAME = 'getComplaintsResponsePathBtn';
        this.FORM_GET_BTN = [this.FORM_GET_BTN_NAME];
        this.FORM_SIMILAR_TYPE = this.FORM['complaint_response[similar_type][]'][1];
        this.TBODY = document.getElementById('complaintResponsesTableBody');
        this.TBODY_NOT_FOUND = document.getElementById('complaintResponsesNotFound');
        this.TBODY_SPINNER = document.getElementById('complaintResponsesTableBodySpinner');
        this.IS_JSON_AVAILABLE_CREATE = true;
        this.IS_JSON_AVAILABLE_GET = true;
        this.IS_JSON_AVAILABLE_DELETE = true;
        this.IS_JSON_AVAILABLE_REGISTERED = true;
        this.JSON_LAST_ID = 0;
        this.JSON_PER_PAGE = 20;
        this.JSON_HAS_MORE = true;
        this.JSON_HAS_MORE_GET = true;
        this.TBODY_DELETE_BTN_NAME = 'deleteComplaintResponse';
        this.DIS_SELECT_BTN = this.FORM['disSelectBtn'];
    }


    clearForm() {
        this.FORM_DATE.value = '';
        this.FORM_CLASSIFICATION.value = '';
        this.FORM_CONTENT.value = '';
        this.FORM_SIMILAR_TYPE.removeAttribute('disabled');
        this.handleDisSelectBtn();
    }


    handleRegisteredBtn(elm) {
        if(elm.classList.contains('btn-success')) {
            elm.classList.add('btn-outline-secondary', 'text-secondary');
            elm.classList.remove('btn-success');
            elm.href = elm.href.split('?is_registered=')[0] + '?is_registered=1';
        } else {
            elm.classList.add('btn-success');
            elm.classList.remove('btn-outline-secondary', 'text-secondary');
            elm.href = elm.href.split('?is_registered=')[0] + '?is_registered=0';
        }
    }


    append(complaintResponses, classification, isRegistered, similarType, insertBefore = false) {
            const fragment = document.createDocumentFragment();
            for(let i = 0; i < complaintResponses.length; i++) {
                const o = complaintResponses[i];
                const tr = document.createElement('TR');
                fragment.appendChild(tr);
// This is just case when you want to download all accounts, etc.
//                    const inputTd = document.createElement('TD');
//                    tr.appendChild(inputTd);
//                    const input = document.createElement('INPUT');
//                    input.type = 'checkbox';
//                    input.name = this.MEDIES_ACCOUNT_CHK_NAME;
//                    input.value = o.id;
//                    inputTd.appendChild(input);
                const dateTd = document.createElement('TD');
                dateTd.textContent = o.date.split('T')[0];
                tr.appendChild(dateTd);
                const classTd = document.createElement('TD');
                classTd.textContent = o.classification != null ? classification[o.classification] : '';
                tr.appendChild(classTd);
                const similarTypeTd = document.createElement('TD');
                if(o.similar_type.length > 0) {
                    let similarTypeArr = [];
                    for(let similarTypeIdx = 0; similarTypeIdx < o.similar_type.length; similarTypeIdx++) {
                        if(o.similar_type[similarTypeIdx] === '') continue;
                        similarTypeArr.push(similarType[o.similar_type[similarTypeIdx]]);
                    }
                    similarTypeTd.innerHTML = similarTypeArr.join('<br/>');
                }
                tr.appendChild(similarTypeTd);
                const content = document.createElement('TD');
                content.innerHTML = Util.EscapeHtml(o.content).replace(/\n/g, '<br/>');
                tr.appendChild(content);
                const actionTd = document.createElement('TD');
                actionTd.classList.add('actions-cell');
                tr.appendChild(actionTd);
                const deleteA = document.createElement('A');
                deleteA.classList.add('btn', 'btn-delete');
                deleteA.textContent = '削除';
                deleteA.href = this.FORM.action + '/' + o.id;
                deleteA.setAttribute('rel', 'nofollow');
                deleteA.dataset.remote = 'true';
                deleteA.dataset.method = 'delete';
                deleteA.dataset.confirm = "本当に削除してもよろしいですか？"
                deleteA.name = this.TBODY_DELETE_BTN_NAME;
                actionTd.appendChild(deleteA);
                const registerA = document.createElement('A');
                if(o.is_registered === 1) {
                    registerA.classList.add('btn', 'btn-success');
                    registerA.href = this.FORM.dataset.registeredAction + '/' + o.id + '?is_registered=0';
                } else {
                    registerA.classList.add('btn', 'btn-outline-secondary', 'text-secondary');
                    registerA.href = this.FORM.dataset.registeredAction + '/' + o.id + '?is_registered=1';
                }
                registerA.textContent = isRegistered[1];
                registerA.setAttribute('rel', 'nofollow');
                registerA.dataset.remote = 'true';
                registerA.dataset.method = 'post';
                registerA.dataset.rujs = 'registered';
                actionTd.appendChild(registerA);
            }
            if(insertBefore) {
                this.TBODY.insertBefore(fragment, this.TBODY.childNodes[0]);
            } else {
                this.TBODY.appendChild(fragment);
            }
    }


    setUpScrollEventListener() {
        let scrollTimerId;
        window.addEventListener('scroll', (e) => {
            if(scrollTimerId != null) {
                clearTimeout(scrollTimerId);
            }
            scrollTimerId = setTimeout(() => {
                const y = window.pageYOffset + window.innerHeight - (window.pageYOffset + this.TBODY.getBoundingClientRect().y);
                const height = this.TBODY.offsetHeight;
                if(height !== 0 && y > height * 0.9) {
                    if(this.IS_JSON_AVAILABLE_GET && this.JSON_HAS_MORE_GET) {
                        this.getComplaintResponses();
                    }
                }
            }, 500);
        }, false);
    }


    handleBeforeSend(e) {
        if(e.target.name !== this.TBODY_DELETE_BTN_NAME && e.target.name !== this.FORM_NAME && e.target.nodeName !== 'A') {
            return;
        }
        const target = e.target;
        if(target.name === this.TBODY_DELETE_BTN_NAME) {
            if(!this.IS_JSON_AVAILABLE_DELETE) {
                e.preventDefault();
                return;
            }
            this.IS_JSON_AVAILABLE_DELETE = false;
        } else if(target.name === this.FORM_NAME) {
            if(!this.IS_JSON_AVAILABLE_CREATE) {
                e.preventDefault();
                return;
            }
            this.IS_JSON_AVAILABLE_CREATE = false;
        } else if(target.dataset.rujs === 'registered') {
            if(!this.IS_JSON_AVAILABLE_REGISTERED) {
                e.preventDefault();
                return;
            }
            this.IS_JSON_AVAILABLE_REGISTERED = false;
        }
        Util.DelDomValidateError();
        Util.DelDomValidateErrorOnlyInvalidElm(this.FORM_SIMILAR_TYPE);
    }


    handleSuccessDelete(elm) {
        elm.parentElement.parentElement.remove();
        this.IS_JSON_AVAILABLE_DELETE = true;
        if(this.TBODY.children.length === 0 && !this.JSON_HAS_MORE_GET) {
            this.TBODY_NOT_FOUND.classList.remove('d-none');
        }
    }


    handleSuccessCreate(detail) {
        const o = detail[0];
        if(o == null) {
            return;
        }
        const complaintResponses = o.complaint_responses;
        const classification = o.classification;
        const isRegistered = o.is_registered;
        const similarType = o.similar_type;
        if(complaintResponses != null) {
            this.append(complaintResponses, classification, isRegistered, similarType, true);
            if(this.TBODY.children.length > 0) {
                this.TBODY_NOT_FOUND.classList.add('d-none');
            }
        }
        this.clearForm();
    }


    handleSuccess(e) {
        if(e.target.name !== this.TBODY_DELETE_BTN_NAME && e.target.name !== this.FORM_NAME && e.target.nodeName !== 'A') {
            return;
        }
        const target = e.target;
        if(target.name === this.TBODY_DELETE_BTN_NAME) {
            this.handleSuccessDelete(target);
        } else if(e.target.name === this.FORM_NAME) {
            this.handleSuccessCreate(e.detail);
        } else if(e.target.dataset.rujs === 'registered') {
            this.handleRegisteredBtn(target);
        }
    }


    handleErrorCreate(detail) {
        const valid = detail.valid;
        if(valid != null) {
            if(valid['date'] != null && valid['date'][0] != null) {
                Util.GenDomValidateError(this.FORM_DATE, valid['date'][0]);
            }
            if(valid['classification'] != null && valid['classification'][0] != null) {
                Util.GenDomValidateError(this.FORM_CLASSIFICATION, valid['classification'][0]);
            }
            if(valid['content'] != null && valid['content'][0] != null) {
                Util.GenDomValidateError(this.FORM_CONTENT, valid['content'][0]);
            }
            if(valid['similar_type'] != null && valid['similar_type'][0] != null) {
                Util.GenDomValidateErrorWithColumnName(this.FORM_SIMILAR_TYPE, '類型化項目', valid['similar_type'][0]);
            }
        }
    }


    handleError(e) {
        if(e.target.name !== this.TBODY_DELETE_BTN_NAME && e.target.name !== this.FORM_NAME && e.target.nodeName !== 'A') {
            return;
        }
        if(e.detail[2] != null && e.detail[2].status === 401) {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(e.detail[0]), this.CONFIG.APP_MAIN.childNodes[0]);
            window.scrollTo(0,0)
            return;
        }
        const detail = e.detail[0];
        if(detail == null) {
            return;
        }
        const msg = detail.msg;
        if(msg != null && msg !== '') {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(msg), this.CONFIG.APP_MAIN.childNodes[0]);
        }
        if(e.target.name === this.FORM_NAME) {
           this.handleErrorCreate(detail);
        }
        window.scrollTo(0, 0);
    }


    handleComplete(e) {
        if(e.target.name !== this.TBODY_DELETE_BTN_NAME && e.target.name !== this.FORM_NAME && e.target.nodeName !== 'A') {
            return;
        }
        if(e.target.name === this.FORM_NAME) {
           this.IS_JSON_AVAILABLE_CREATE = true;
        } else if(e.target.dataset.rujs === 'registered') {
            this.IS_JSON_AVAILABLE_REGISTERED = true;
        }
    }


    setUpRailsUjsEventListener() {
        document.body.addEventListener('ajax:beforeSend', (e) => { this.handleBeforeSend(e) }, false);
        document.body.addEventListener('ajax:success', (e) => { this.handleSuccess(e) }, false);
        document.body.addEventListener('ajax:error', (e) => { this.handleError(e) }, false);
        document.body.addEventListener('ajax:complete', (e) => { this.handleComplete(e) }, false);
    }


    getComplaintResponses() {
        if(!this.IS_JSON_AVAILABLE_GET) {
            return;
        }
        this.IS_JSON_AVAILABLE_GET = false;
        this.TBODY_SPINNER.classList.remove('invisible');
        const formData = new FormData();
        formData.append('complaint_response[last_id]', this.JSON_LAST_ID);
        formData.append('complaint_response[per_page]', this.JSON_PER_PAGE);
        formData.append('complaint_response[complaint_id]', this.FORM_COMPLAINT_ID.value);

        Rails.ajax({
            type: this.FORM.method,
            url: this.FORM.dataset.getAction,
            data: formData,
            success: (repsonse) => {
                const complaintResponses = repsonse.complaint_responses;
                const classification = repsonse.classification;
                const isRegistered = repsonse.is_registered;
                const similarType = repsonse.similar_type;
                if(complaintResponses != null && complaintResponses.length > 0) {
                    this.JSON_LAST_ID = complaintResponses[complaintResponses.length-1].id;
                    this.append(complaintResponses, classification, isRegistered, similarType);
                } else {
                    if(this.JSON_LAST_ID === 0) {
                        this.TBODY_NOT_FOUND.classList.remove('d-none');
                    }
                    this.JSON_HAS_MORE_GET = false;
                }
            },
            error: (repsonse) => {
                if(repsonse != null && repsonse !== '') {
                    this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(repsonse), this.CONFIG.APP_MAIN.childNodes[0]);
                }
                console.log(repsonse);
            },
            complete: () => {
                this.IS_JSON_AVAILABLE_GET = true;
                this.TBODY_SPINNER.classList.add('invisible');
            }
        })
    }

    handleDisSelectBtn() {
        const options = this.FORM_SIMILAR_TYPE.getElementsByTagName('OPTION');
        for(let i = 0; i < options.length; i++) {
            options[i].selected = false;
        }
    }

    handleSelectClassification() {
        if(this.FORM_CLASSIFICATION.value === "2") {
            this.handleDisSelectBtn();
            this.FORM_SIMILAR_TYPE.setAttribute('disabled', true);
        } else {
            this.FORM_SIMILAR_TYPE.removeAttribute('disabled');
        }

    }

    setUpClickEventListener() {
        this.DIS_SELECT_BTN.addEventListener('click', () => { this.handleDisSelectBtn(); }, false);
        this.FORM_CLASSIFICATION.addEventListener('change', () => { this.handleSelectClassification();}, false)
    }

    Run() {
        this.setUpScrollEventListener();
        this.setUpRailsUjsEventListener();
        this.getComplaintResponses();
        this.setUpClickEventListener();
    }

}
export { ComplaintResponses }
